// extracted by mini-css-extract-plugin
export default {"severity":"ServerIncidentSeverityBadge_severity__F8ZB3","warning":"ServerIncidentSeverityBadge_warning__LWQuF","critical":"ServerIncidentSeverityBadge_critical__mu-Zm"};